import React from "react";
import SMSSubscriptionList from "../../../components/Pages/Subscription/SMS/List";

const SMSSubscription = () => {
  return (
    <div>
      <SMSSubscriptionList />
    </div>
  );
};

export default SMSSubscription;
